import {FC} from 'react';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import {Box, IconButton, Tooltip} from '@mui/material';

interface Props {
  value: string;
  tooltip?: string;
}

export const CopyableText: FC<Props> = ({value, tooltip = 'Copy'}) => (
  <Box display="flex" alignItems="center" gap={0.5}>
    {value}

    <Tooltip title={tooltip}>
      <IconButton
        size="small"
        onClick={() => void navigator.clipboard.writeText(value)}
      >
        <ContentCopyIcon sx={{fontSize: 14}} />
      </IconButton>
    </Tooltip>
  </Box>
);
